import { Component, ViewChild } from '@angular/core';
import { HeaderComponent } from '../../components/header/header.component';
import { FooterComponent } from '../../components/footer/footer.component';
import { NgFor, NgIf, SlicePipe, DatePipe } from '@angular/common';
import { DatasearchService } from '../../_services/datasearch.service';

@Component({
  selector: 'app-about-us',
  standalone: true,
  imports: [HeaderComponent, FooterComponent, NgFor, NgIf, SlicePipe, DatePipe],
  templateUrl: './about-us.component.html',
  styleUrl: './about-us.component.scss'
})
export class AboutUsComponent {
  @ViewChild('aboutVideo') aboutVideo: any;
  awardBaseUrl = this.datasearch_service.ApiUrl + '/uploads/awards/';
  awarding: any = [];
  content = "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna";
  aboutIntoVideo = this.datasearch_service.ApiUrl + '/uploads/web_videos/ChemRobotics-AgroPat-Tutorial-Agrochemical-Pesticide.mp4';
  aboutThumbnail = this.datasearch_service.ApiUrl + '/assets/images/banner/about-banner.png';
  logoBasicUrl = this.datasearch_service.ApiUrl + '/uploads/partners/';
  teamBaseUrl = this.datasearch_service.ApiUrl + '/uploads/team_members/';
  aboutbaseurl = this.datasearch_service.ApiUrl + '/uploads/about_us/'
  partners: any = [];
  aboutusdata: any = [];
  head: any[] = [];
  currentPage: string = 'about us';
  readMoreState: boolean[] = [];
  currentUrl: string;
  //  cards: any[] = [
  //   { 
  //       logo: 'pna.png',
  //   },
  //   { 
  //       logo: 'agbio.png',
  //   },
  //   { 
  //       logo: 'defiance.png',
  //   },
  //   { 
  //       logo: 'ample.png',
  //   },
  //   { 
  //       logo: 'kisaan.png',
  //   }
  // ];
  //   boxes: any[] = [
  //     {
  //         title: '5000+',
  //         des: 'Projects Delivered',
  //     },
  //     {
  //         title: '2000+',
  //         des: 'Clients',
  //     },
  //     {
  //         title: '75+',
  //         des: 'Countries',
  //     },
  //     {
  //         title: '25+',
  //         des: 'Specialized Industry Focus',
  //     },
  // ];



  constructor(private datasearch_service: DatasearchService) {
    this.readMoreState = this.awarding.map(() => false);
    this.currentUrl = window.location.href; // Get the current URL
  }

  ngOnInit() {
    this.getCards();
    this.getPartnerData();
    this.getHeading();
    this.getAboutUs();
  }

  getCards() {

    this.datasearch_service.getAwards().subscribe((res) => {
      this.awarding = res.data;
      // console.log(this.awards);
    },
      (error) => {
        // console.log(error);
      })
  }
  getPartnerData() {
    this.datasearch_service.getPartners().subscribe(res => {
      this.partners = res.data;
      // console.log(this.partners); // Log the data to check if logos are valid
    });
  }

  getAboutUs() {
    this.datasearch_service.getAboutus().subscribe(res => {
      this.aboutusdata = res.data;
    });
  }
  getHeading() {
    this.datasearch_service.getAllHeadings().subscribe(res => {
      if (res.success) {
        this.head = res.data.filter((heading: any) => heading.page === this.currentPage);
      }
    });
  }
  toggleVideo() {
    const video: HTMLVideoElement = this.aboutVideo.nativeElement;
    if (video.paused) {
      video.play();
    } else {
      video.pause();
    }
  }

  getMediaUrl(filename: string | undefined, folder: string): string {
    if (!filename) return 'https://www.chemrobotics.com/agropat/uploads/gallery/placeholder.png';
    if (filename.startsWith('http')) return filename;

    // Prevent double pathing by checking if "uploads/" is already present
    let cleanPath = filename.replace(/^\//, ''); // Remove leading slash if any

    if (!cleanPath.includes('uploads/')) {
      cleanPath = `uploads/${folder}/` + cleanPath;
    }

    // Ensure accurate prefix (strip trailing slashes from ApiUrl)
    const baseUrl = this.datasearch_service.ApiUrl.replace(/\/$/, '');
    return `${baseUrl}/${cleanPath}`;
  }

  toggleReadMore(index: number) {
    this.readMoreState[index] = !this.readMoreState[index];
  }
  openLink(url: string) {
    if (url) {
      window.open(url, '_blank');
    }
  }
  shareViaEmail() {
    const subject = 'Check out this page!';
    const body = `Here is the link: ${this.currentUrl}`;
    const mailtoLink = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

    window.location.href = mailtoLink; // Open the email client
  }

  shareViaSMS() {
    const smsLink = `sms:?body=${encodeURIComponent(this.currentUrl)}`;
    window.location.href = smsLink; // Open SMS app
  }

  shareViaWhatsApp() {
    const text = `Check this out! ${this.currentUrl}`;
    const whatsappLink = `https://wa.me/?text=${encodeURIComponent(text)}`;

    window.open(whatsappLink, '_blank'); // Open WhatsApp share dialog
  }

  shareViaMessenger() {
    const messengerLink = `https://www.messenger.com/share/?link=${encodeURIComponent(this.currentUrl)}`;
    window.open(messengerLink, '_blank'); // Open Messenger share dialog
  }

  shareViaViber() {
    const viberLink = `viber://forward?text=${encodeURIComponent(this.currentUrl)}`;
    window.open(viberLink, '_blank'); // Open Viber share dialog
  }

  shareViaFacebook() {
    const facebookLink = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(this.currentUrl)}`;

    window.open(facebookLink, '_blank'); // Open Facebook share dialog
  }

  shareViaTwitter() {
    const text = `Check this out! ${this.currentUrl}`;
    const twitterLink = `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}`;

    window.open(twitterLink, '_blank'); // Open Twitter share dialog
  }

  shareViaLinkedIn() {
    const linkedInLink = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(this.currentUrl)}`;
    window.open(linkedInLink, '_blank'); // Open LinkedIn share dialog
  }

  shareViaPinterest() {
    const pinterestLink = `https://pinterest.com/pin/create/button/?url=${encodeURIComponent(this.currentUrl)}`;
    window.open(pinterestLink, '_blank'); // Open Pinterest share dialog
  }

  shareViaReddit() {
    const redditLink = `https://www.reddit.com/submit?url=${encodeURIComponent(this.currentUrl)}`;
    window.open(redditLink, '_blank'); // Open Reddit share dialog
  }

  shareViaTumblr() {
    const tumblrLink = `https://www.tumblr.com/share/link?url=${encodeURIComponent(this.currentUrl)}`;
    window.open(tumblrLink, '_blank'); // Open Tumblr share dialog
  }

  shareViaTelegram() {
    const telegramLink = `https://t.me/share/url?url=${encodeURIComponent(this.currentUrl)}`;
    window.open(telegramLink, '_blank'); // Open Telegram share dialog
  }

  shareViaVK() {
    const vkLink = `https://vk.com/share.php?url=${encodeURIComponent(this.currentUrl)}`;
    window.open(vkLink, '_blank'); // Open VK share dialog
  }

  shareViaMix() {
    const mixLink = `https://mix.com/add?url=${encodeURIComponent(this.currentUrl)}`;
    window.open(mixLink, '_blank'); // Open Mix share dialog
  }

  shareViaXing() {
    const xingLink = `https://www.xing.com/app/user?op=share;url=${encodeURIComponent(this.currentUrl)}`;
    window.open(xingLink, '_blank'); // Open Xing share dialog
  }

  shareViaLine() {
    const lineLink = `https://line.me/R/share?text=${encodeURIComponent(this.currentUrl)}`;
    window.open(lineLink, '_blank'); // Open Line share dialog
  }

  copyLink() {
    navigator.clipboard.writeText(this.currentUrl).then(() => {
      alert('Link copied to clipboard!');
    });
  }
}
